import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Toastr from 'components/Toastr';

import injectReducer from 'utils/injectReducer';
import {
  makeSelectNotificationMessage,
  makeSelectNotificationMessageType,
  makeSelectNotificationVisibility,
} from './selectors';
import reducer from './reducer';
import { hideToastr } from './actions';

function ToastrMessage(props) {
  // eslint-disable-line react/prefer-stateless-function
  return <Toastr {...props} onDismissMessage={props.onDismissMessage} />;
}

ToastrMessage.propTypes = {
  onDismissMessage: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  messageType: makeSelectNotificationMessageType(),
  message: makeSelectNotificationMessage(),
  show: makeSelectNotificationVisibility(),
});

function mapDispatchToProps(dispatch) {
  return {
    onDismissMessage: () => dispatch(hideToastr()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'notification', reducer });

export default compose(
  withReducer,
  withConnect
)(ToastrMessage);



// WEBPACK FOOTER //
// ./app/containers/Toastr/index.js